/**
 * Template for an email
 */
export interface IOcbEmailTemplate {
    /**
     * Gets or sets the internal identifier of the environment
     */
    environmentId: string;
    /**
     * Gets or sets the name of the environment
     */
    environmentName?: string;
    /**
     * Gets or sets the type of the email
     */
    emailType?: EmailType;
    /**
     * Gets or sets the subject of the email
     */
    subject: string;
    /**
     * Gets or sets the message
     */
    message: string;
}

export enum EmailType {
    TransferSucceeded = 0,
    TransferFailed = 1,
    ACKKOFileReceived = 2,
    ACKOKFileReceived = 3,
    NoACKReceived = 4,
    FileAlreadyExistsInTarget = 5,
    CredentialsError = 6,
    TechnicalError = 7,
    UnknownACKFileReceived = 8,
    UnknownFileReceived = 9,
    ContactLostWithAgent = 10,
    CommandExpired = 11,
    EmptyFileIgnored = 12,
}
